import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MomentModule } from 'ngx-moment';
import { CountdownModule } from 'ngx-countdown';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { ChartsModule } from 'ng2-charts';
import { PipesModule } from './../shared/pipes/pipes.module';

import { TermsConditionComponent } from './terms-condition/terms-condition.component';
import { AssessmentRulesComponent } from './assessment-rules/assessment-rules.component';
import { AssessmentService } from './shared/services/assessment.service';
import { QuestionViewComponent } from './question-view/question-view.component';
import { ConfidenceRelevanceComponent } from './confidence-relevance/confidence-relevance.component';
import { QuestionAnswerComponent } from './question-answer/question-answer.component';
import { AssessmentComponent } from './assessment.component';
import { GraphComponent } from './graph/graph.component';
import { ReviewQuestionComponent } from './review-question/review-question.component';
import { ResultReviewComponent } from './result-review/result-review.component';
import { BlockPrintDirective } from '../shared/directives/block-print.directive';
import { GetEmailComponent } from './get-email/get-email.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    MomentModule,
    CountdownModule,
    FormsModule,
    ReactiveFormsModule,
    ChartsModule,
    PipesModule
  ],
  declarations: [
    TermsConditionComponent,
    AssessmentRulesComponent,
    QuestionViewComponent,
    ConfidenceRelevanceComponent,
    QuestionAnswerComponent,
    AssessmentComponent,
    GraphComponent,
    ReviewQuestionComponent,
    ResultReviewComponent,
    BlockPrintDirective,
    GetEmailComponent
  ],
  providers: [AssessmentService]
})
export class AssessmentModule { }
